import React from 'react';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  StaticPageHeader,
  NamedLink,
} from '../../components';
import config from '../../config';

import IconCoins from './IconCoins';
import IconShipping from './IconShipping';
import IconPayment from './IconPayment';
import heroImage from './hero.jpg';
import css from './SupportPage.module.css';

const categoryLink = (name, heading, icon, params) => {
  return (
    <NamedLink className={css.supportCategory} name={name} params={{ ...params }}>
      {icon}
      <h3 className={css.categoryHeading}>{heading}</h3>
    </NamedLink>
  );
};

const SupportPageComponent = props => {
  const { intl } = props;
  const { siteTitle } = config;

  const headerTitle = intl.formatMessage({ id: 'SupportPage.headerTitle' });

  const tipsToSellHeading = intl.formatMessage({
    id: 'SupportPage.tipsToSellHeading',
  });
  const shippingHeading = intl.formatMessage({
    id: 'SupportPage.shippingHeading',
  });
  const paymentMethodsHeading = intl.formatMessage({
    id: 'SupportPage.paymentMethodsHeading',
  });

  const contactLinkMessage = intl.formatMessage({ id: 'SupportPage.contactLink' });
  const contactLink = <NamedLink name="ContactPage">{contactLinkMessage}</NamedLink>;
  return (
    <StaticPage
      title={`Support | ${siteTitle}`}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'SupportPage',
        description: 'Support',
        name: 'SupportPage',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <StaticPageHeader
            titleClassName={css.headerTitle}
            title={headerTitle}
            currentPage="SupportPage"
            heroImage={heroImage}
            largeHeader
          />
          <div className={css.contentWrapper}>
            <div className={css.supportCategories}>
              {categoryLink(
                'TipsSupportPage',
                tipsToSellHeading,
                <IconCoins className={css.supportCategoryIcon} />,
                { slug: 'first-article' }
              )}
              {categoryLink(
                'ShippingSupportPage',
                shippingHeading,
                <IconShipping className={css.supportCategoryIcon} />,
                { slug: 'first-article' }
              )}
              {categoryLink(
                'PaymentSupportPage',
                paymentMethodsHeading,
                <IconPayment className={css.supportCategoryIcon} />,
                { slug: 'first-article' }
              )}
            </div>
            <div className={css.contactBox}>
              <h3 className={css.contactHeading}>
                <FormattedMessage id="SupportPage.contactHeading" />
              </h3>
              <p className={css.contactText}>
                <FormattedMessage id="SupportPage.contactText" values={{ contactLink }} />
              </p>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

SupportPageComponent.propTypes = {
  intl: intlShape.isRequired,
};

const SupportPage = compose(injectIntl)(SupportPageComponent);

export default SupportPage;
